import React, { Suspense } from 'react'
import Modal, { Header } from 'src/components/theme/Models/Modal'
import Form from './Form'

interface EditModalProps {
  toggle: (id?: string) => void
  id: string | undefined
  lookupId: string
}

const EditModal: React.FC<EditModalProps> = (props) => {
  const { toggle, id, lookupId } = props
  const isOpen = typeof id === 'string'
  return (
    <Modal
      title='Edit Lookup Option'
      isOpen={isOpen}
      toggle={() => toggle(undefined)}
    >
      <Header title='Edit Lookup Option' />
      <Suspense fallback={<div>Loading...</div>}>
        <Form id={id} toggle={toggle} lookupId={lookupId} />
      </Suspense>
    </Modal>
  )
}

export default EditModal
